import React from 'react';
import { motion } from 'framer-motion';
import { TerminalIcon, NetworkIcon, CpuIcon, ArrowRightIcon, CodeIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function HowItWorksSlide() {
  return <SlideLayout data-id="element-202" data-mp="cmwlrb5hmfll">
      <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-203" data-mp="hfpppwt4tjwm">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-204" data-mp="hh0u9yueivos">
          A Cloud API Powered by High-Performance FPGAs
        </h2>
      </motion.div>

      {/* Architecture Diagram */}
      <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center justify-between gap-4 mb-20 relative" data-id="element-205" data-mp="qekz1hrh3a45">
        {/* Connecting Line Background (Desktop) */}
        <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-border -translate-y-1/2 z-0" data-id="element-206" data-mp="10chfmp36ix9n" />

        {/* Step 1 */}
        <div className="bg-brand-bg-card border border-brand-border rounded-xl p-6 w-full md:w-64 relative z-10 flex flex-col items-center text-center" data-id="element-207" data-mp="325f6wghb5hsh">
          <div className="w-12 h-12 bg-brand-bg rounded-full flex items-center justify-center border border-brand-border mb-4" data-id="element-208" data-mp="1ngmkpso97ot4">
            <TerminalIcon className="w-6 h-6 text-brand-text" data-id="element-209" data-mp="1dogv2plh5jh3" />
          </div>
          <h3 className="text-lg font-bold text-brand-text mb-2" data-id="element-210" data-mp="1dmduxcqly9yn">Your App</h3>
          <p className="text-sm text-brand-text-dim" data-id="element-211" data-mp="19ozplw61smbx">Python, curl, SDKs</p>
          <div className="absolute -bottom-3 md:-right-6 md:top-1/2 md:-translate-y-1/2 md:bottom-auto bg-brand-bg p-1 rounded-full border border-brand-border md:border-none" data-id="element-212" data-mp="26ccmbes9yj6h">
            <ArrowRightIcon className="w-5 h-5 text-brand-text-muted rotate-90 md:rotate-0" data-id="element-213" data-mp="1xc7re449pd97" />
          </div>
        </div>

        {/* Step 2 */}
        <div className="bg-brand-bg-card border border-brand-teal rounded-xl p-6 w-full md:w-64 relative z-10 flex flex-col items-center text-center shadow-[0_0_20px_rgba(0,212,170,0.1)]" data-id="element-214" data-mp="1sdd16h3z0mf2">
          <div className="w-12 h-12 bg-brand-teal/10 rounded-full flex items-center justify-center border border-brand-teal/30 mb-4" data-id="element-215" data-mp="gwwi8dt7jnng">
            <NetworkIcon className="w-6 h-6 text-brand-teal" data-id="element-216" data-mp="nepvozjit3ad" />
          </div>
          <h3 className="text-lg font-bold text-brand-text mb-2" data-id="element-217" data-mp="ndy8od3zodvp">
            Isochron API
          </h3>
          <span className="px-2 py-1 bg-brand-teal/10 text-brand-teal text-xs rounded-md font-mono border border-brand-teal/20" data-id="element-218" data-mp="9h19nodpvq3q">
            OpenAI-Compatible
          </span>
          <div className="absolute -bottom-3 md:-right-6 md:top-1/2 md:-translate-y-1/2 md:bottom-auto bg-brand-bg p-1 rounded-full border border-brand-border md:border-none" data-id="element-219" data-mp="3vsyits39x1v5">
            <ArrowRightIcon className="w-5 h-5 text-brand-text-muted rotate-90 md:rotate-0" data-id="element-220" data-mp="3lxeo390g497z" />
          </div>
        </div>

        {/* Step 3 */}
        <div className="bg-brand-bg-card border border-brand-border rounded-xl p-6 w-full md:w-64 relative z-10 flex flex-col items-center text-center" data-id="element-221" data-mp="3qtdf74d5s5c3">
          <div className="w-12 h-12 bg-brand-bg rounded-full flex items-center justify-center border border-brand-border mb-4" data-id="element-222" data-mp="3htqe6jocd1jk">
            <CodeIcon className="w-6 h-6 text-brand-text" data-id="element-223" data-mp="2y98ec5fgwokt" />
          </div>
          <h3 className="text-lg font-bold text-brand-text mb-2" data-id="element-224" data-mp="2tax0ljm1xtxb">
            Isochron Forge
          </h3>
          <p className="text-sm text-brand-text-dim" data-id="element-225" data-mp="37ag1psgg4504">Compiler + Scheduler</p>
          <div className="absolute -bottom-3 md:-right-6 md:top-1/2 md:-translate-y-1/2 md:bottom-auto bg-brand-bg p-1 rounded-full border border-brand-border md:border-none" data-id="element-226" data-mp="337tc7y78yw63">
            <ArrowRightIcon className="w-5 h-5 text-brand-text-muted rotate-90 md:rotate-0" data-id="element-227" data-mp="3c90yfhwho6jt" />
          </div>
        </div>

        {/* Step 4 */}
        <div className="bg-brand-bg-card border border-brand-border rounded-xl p-6 w-full md:w-64 relative z-10 flex flex-col items-center text-center" data-id="element-228" data-mp="3qx46qxy07ubs">
          <div className="w-12 h-12 bg-brand-bg rounded-full flex items-center justify-center border border-brand-border mb-4" data-id="element-229" data-mp="3soa4f681n2g">
            <CpuIcon className="w-6 h-6 text-brand-text" data-id="element-230" data-mp="3v0a9hvlwr3di" />
          </div>
          <h3 className="text-lg font-bold text-brand-text mb-2" data-id="element-231" data-mp="1tal8gmr3v3fl">
            FPGA Cluster
          </h3>
          <p className="text-sm text-brand-text-dim" data-id="element-232" data-mp="1y8mthd83dctp">32GB on-chip RAM</p>
        </div>
      </motion.div>

      {/* Key Points */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-233" data-mp="23166a7yyg3xg">
        <motion.div variants={itemVariants} className="space-y-6" data-id="element-234" data-mp="270ew51qvjhnq">
          <div data-id="element-235" data-mp="1abh0zif7phq1">
            <h4 className="text-brand-teal font-semibold mb-1 flex items-center gap-2" data-id="element-236" data-mp="1abqvnjb7cd22">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-teal" data-id="element-237" data-mp="1fa0rlw4r3hoq" />{' '}
              Standard REST API
            </h4>
            <p className="text-brand-text-dim text-sm" data-id="element-238" data-mp="1jaub8db5uabt">
              Call the same format you already use with OpenAI, OpenRouter, or
              Together AI. Select a model, send a request, receive tokens.
            </p>
          </div>
          <div data-id="element-239" data-mp="2ut5655f7vqvd">
            <h4 className="text-brand-teal font-semibold mb-1 flex items-center gap-2" data-id="element-240" data-mp="2zq5b1d0bynkw">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-teal" data-id="element-241" data-mp="2zrynj8xmk20t" />{' '}
              Proprietary Compiler
            </h4>
            <p className="text-brand-text-dim text-sm" data-id="element-242" data-mp="34uhb6ikq7dzj">
              Isochron Forge optimizes and synthesizes each model directly onto
              FPGA hardware — quantization, dataflow mapping, multi-card
              parallelism.
            </p>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="space-y-6" data-id="element-243" data-mp="2r3b523mxyi3o">
          <div data-id="element-244" data-mp="2r1htqb1dv9pc">
            <h4 className="text-brand-teal font-semibold mb-1 flex items-center gap-2" data-id="element-245" data-mp="2m4hou3g9sczt">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-teal" data-id="element-246" data-mp="2m6ufr6409xp0" />{' '}
              Massive On-Chip Memory
            </h4>
            <p className="text-brand-text-dim text-sm" data-id="element-247" data-mp="2d4begqfvbt4v">
              32 GB of on-chip RAM per card runs an 8B model entirely on-chip.
              Larger models (70B, 430B) distribute automatically.
            </p>
          </div>
          <div className="bg-brand-teal/5 border border-brand-teal/20 rounded-lg p-4" data-id="element-248" data-mp="bdrldgrpv0xt">
            <h4 className="text-brand-text font-semibold mb-1" data-id="element-249" data-mp="24u4be5jmmdup">
              Zero Hardware Management
            </h4>
            <p className="text-brand-text-dim text-sm" data-id="element-250" data-mp="29ngn5f37iq61">
              No FPGA knowledge required. Integration is a single API-key swap.
              You only touch the left side of the diagram.
            </p>
          </div>
        </motion.div>
      </div>
    </SlideLayout>;
}